export const ACTION_STATUS_ERROR = "error";
export const ACTION_STATUS_LOADING = "loading";
export const ACTION_STATUS_SUCCESS = "success";
export const APPLICATION_NAME = "My Legacy Pay Documents";
export const APPLICATION_TITLE = "My Legacy Pay Documents | The Ohio State University";
export const ERROR_NO_CURRENT_USER = "No current user";
export const STYLESHEET_LENGTH = document && document.styleSheets ? document.styleSheets.length : 99
export const DOC_DOWNLOAD="No document found";